import { render, staticRenderFns } from "./FollowupCard.vue?vue&type=template&id=780c2c2a"
import script from "./FollowupCard.vue?vue&type=script&lang=js"
export * from "./FollowupCard.vue?vue&type=script&lang=js"
import style0 from "./FollowupCard.vue?vue&type=style&index=0&id=780c2c2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports